import styled from "styled-components";
import { Box } from "@sqymagma/elements";

export const IconWrapper = styled(Box)`
  cursor: pointer;
  transition: 0.2s ease-in;
  &:hover {
    transform: scale(1.1);
  }
`;

export const SuccessBox = styled(Box)`
  border-radius: ${(p) => p.theme.radii.m};
`;

export const MoodSubmenuAnchor = styled(Box)`
  position: relative;
  & > :last-child {
    z-index: 20;
  }
`;

export const MoodSubmenu = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(p) => p.theme.spacing.xxxs};
  padding: 30px 8px 8px;
  background: ${(p) => p.theme.colors.overlay03};
  backdrop-filter: blur(2px);
  border-radius: 0 0 25px 25px;
  width: fit-content;
  z-index: 10;
  animation: curtainDown 0.25s ease-out;
`;
